export default "{\n    \"drawer\": {\n        \"expand\": \"Expand Navigation\",\n        \"collapse\": \"Collapse Navigation\"\n    }\n}\n"